import {booleanAttribute, ChangeDetectionStrategy, Component, ContentChild, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-flash-alert',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule],
  template: `
      <ng-container *ngIf="showAlert">
          <div class="alert alert-{{ type }} d-flex flex-column justify-content-start flex-sm-row">

              <span class="svg-icon svg-icon-2hx svg-icon-{{ type }} me-4 mb-5 mb-sm-0">
                <svg *ngIf="'success' === type" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                     viewBox="0 0 24 24"
                     fill="none">
                    <path opacity="0.3"
                          d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                          fill="black"/>
                    <path
                            d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z"
                            fill="black"/>
                </svg>
                <svg *ngIf="'info' === type" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                                              <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10"
                                                    fill="black"/>
                                              <rect x="11" y="17" width="7" height="2" rx="1"
                                                    transform="rotate(-90 11 17)"
                                                    fill="black"/>
                                              <rect x="11" y="9" width="2" height="2" rx="1"
                                                    transform="rotate(-90 11 9)"
                                                    fill="black"/>
                                          </svg>
                <svg *ngIf="'danger' === type || 'warning' === type" width="24" height="24" viewBox="0 0 24 24"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3"
                        d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                        fill="black"/>
                  <rect x="9" y="13.0283" width="7.3536" height="1.2256" rx="0.6128" transform="rotate(-45 9 13.0283)"
                        fill="black"/>
                  <rect x="9.86664" y="7.93359" width="7.3536" height="1.2256" rx="0.6128"
                        transform="rotate(45 9.86664 7.93359)" fill="black"/>
              </svg>
              </span>

              <div class="d-flex flex-column"
                   [class.justify-content-center]="(undefined === title && undefined !== message) || (undefined !== title && undefined === message)"
              >
                  <h4 class=" text-{{ type }}" *ngIf="undefined !== title">{{ title }}</h4>
                  <span *ngIf="undefined !== message" [innerHTML]="message"></span>
              </div>

              <button
                      type="button"
                      class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                      *ngIf="isDismissible"
                      (click)="hide()"
              >
        <span class="svg-icon svg-icon-2x svg-icon-{{ type }}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="7.05025" y="15.5356" width="12" height="2" rx="1"
                      transform="rotate(-45 7.05025 15.5356)" fill="black"/>
                <rect x="8.46447" y="7.05029" width="12" height="2" rx="1"
                      transform="rotate(45 8.46447 7.05029)" fill="black"/>
            </svg>
        </span>
              </button>
          </div>
      </ng-container>
  `,
  styles: [`

    .alert {
      --bs-alert-bg: transparent;
      --bs-alert-padding-x: 1rem;
      --bs-alert-padding-y: 1rem;
      --bs-alert-margin-bottom: 1rem;
      --bs-alert-color: inherit;
      --bs-alert-border-color: transparent;
      --bs-alert-border: 1px solid var(--bs-alert-border-color);
      --bs-alert-border-radius: 0.475rem;
      position: relative;
      padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
      margin-bottom: var(--bs-alert-margin-bottom);
      color: var(--bs-alert-color);
      background-color: var(--bs-alert-bg);
      border: var(--bs-alert-border);
      border-radius: var(--bs-alert-border-radius);
    }

    .alert-success {
      --bs-alert-color: #205237;
      --bs-alert-bg: #dcf5e7;
      --bs-alert-border-color: #cbf0dc;
    }

    .alert-info {
    --bs-alert-color: #44228c;
    --bs-alert-bg: #e3d7fb;
    --bs-alert-border-color: #d5c4f9;
    }

    .alert-danger {
    --bs-alert-color: #912741;
    --bs-alert-bg: #fcd9e2;
    --bs-alert-border-color: #fbc6d3;
    }

    .alert-warning {
    --bs-alert-color: #665000;
    --bs-alert-bg: #fff4cc;
    --bs-alert-border-color: #ffeeb3;
    }

    .svg-icon.svg-icon-success svg [fill]:not(.permanent):not(g) {
      transition: fill 0.3s ease;
      fill: #50CD89;
    }

    .svg-icon.svg-icon-info svg [fill]:not(.permanent):not(g) {
      transition: fill 0.3s ease;
      fill: #7239EA;
    }

    .svg-icon.svg-icon-danger svg [fill]:not(.permanent):not(g) {
      transition: fill 0.3s ease;
      fill: #F1416C;
    }

    .svg-icon.svg-icon-warning svg [fill]:not(.permanent):not(g) {
      transition: fill 0.3s ease;
      fill: #FFC700;
    }

  `]
})
/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class FlashAlertComponent implements OnChanges{

  @Input({required: true}) type: 'success' | 'info' | 'danger' | 'warning' | 'error' | string
  @Input({required: false}) title?: string
  @Input({required: false}) message?: string
  @Input({required: false, transform: booleanAttribute}) isDismissible: boolean = true

  showAlert: boolean = false;

  ngOnChanges(): void {
    this.showAlert = undefined !== this.title || undefined !== this.message;
    this.changeTypeIfIsError();
  }

  changeTypeIfIsError () {
    if ('error' === this.type) this.type = 'danger'
  }

  hide() {
    this.showAlert = false;
  }
}
